export const ALLOWED_COUNTRIES_UK = ['GB']

export const ALLOWED_COUNTRIES_US = ['US']

export const ALLOWED_COUNTRIES_EU = [
  // 'AT',
  'BE',
  // 'DK',
  'FR',
  'DE',
  'IE',
  // 'IT',
  'NL',
  // 'PL',
  'ES',
  'SE'
  // 'CZ',
]

export const EU_COUNTRY_LABELS = {
  AT: 'Austria',
  BE: 'Belgium',
  CH: 'Switzerland',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DK: 'Denmark',
  ES: 'Spain',
  FI: 'Finland',
  FR: 'France',
  HU: 'Hungary',
  IE: 'Ireland',
  IT: 'Italy',
  LU: 'Luxembourg',
  NL: 'Netherlands',
  NO: 'Norway',
  PL: 'Poland',
  PT: 'Portugal',
  SE: 'Sweden'
}
